/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Socialindicatorschema2Inputs */

const de__field_socialindicatorschema2 = /** @type {(inputs: _Field_Socialindicatorschema2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialindikator (jüngster Stand)`)
};

/**

* @param {_Field_Socialindicatorschema2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_socialindicatorschema2 = /** @type {((inputs?: _Field_Socialindicatorschema2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Socialindicatorschema2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_socialindicatorschema2(inputs)
});
export { _field_socialindicatorschema2 as "_field_socialIndicatorSchema" }